// Generated by Scripts/compile-product-event-contract.mjs from the canonical catalogue. Do not edit.

const deepFreeze = (value) => {
  for (const child of Object.values(value)) {
    if (child && typeof child === "object") deepFreeze(child);
  }
  return Object.freeze(value);
};

export const webSamplingDefaults = deepFreeze({
  "guest_shared_list_view": 1,
  "guest_shared_list_access_error": 1,
  "guest_shared_list_availability": 1,
  "guest_shared_list_action": 1,
  "guest_shared_list_cta_impression": 1,
  "guest_shared_list_cta_click": 1
});
export const webProductEventContracts = deepFreeze({
  "guest_shared_list_view": {
    "eventSchemaVersion": 1,
    "properties": {
      "surface": {
        "type": "string",
        "enum": [
          "shared_list"
        ]
      },
      "access_state": {
        "type": "string",
        "enum": [
          "editable",
          "read_only",
          "expired",
          "access_unavailable",
          "not_found",
          "load_error"
        ]
      },
      "cta_mode": {
        "type": "string",
        "enum": [
          "testflight",
          "app_store",
          "download"
        ]
      }
    }
  },
  "guest_shared_list_access_error": {
    "eventSchemaVersion": 1,
    "properties": {
      "surface": {
        "type": "string",
        "enum": [
          "shared_list"
        ]
      },
      "access_state": {
        "type": "string",
        "enum": [
          "editable",
          "read_only",
          "expired",
          "access_unavailable",
          "not_found",
          "load_error"
        ]
      },
      "cta_mode": {
        "type": "string",
        "enum": [
          "testflight",
          "app_store",
          "download"
        ]
      },
      "result": {
        "type": "string",
        "enum": [
          "blocked"
        ]
      }
    }
  },
  "guest_shared_list_availability": {
    "eventSchemaVersion": 1,
    "properties": {
      "surface": {
        "type": "string",
        "enum": [
          "shared_list"
        ]
      },
      "phase": {
        "type": "string",
        "enum": [
          "detected",
          "recovered"
        ]
      },
      "mode": {
        "type": "string",
        "enum": [
          "prolonged_loading",
          "saved_snapshot"
        ]
      },
      "connection_state": {
        "type": "string",
        "enum": [
          "online",
          "offline"
        ]
      }
    }
  },
  "guest_shared_list_action": {
    "eventSchemaVersion": 1,
    "properties": {
      "surface": {
        "type": "string",
        "enum": [
          "shared_list"
        ]
      },
      "access_state": {
        "type": "string",
        "enum": [
          "editable",
          "read_only",
          "expired",
          "access_unavailable",
          "not_found",
          "load_error"
        ]
      },
      "action": {
        "type": "string",
        "enum": [
          "add_item",
          "toggle_item",
          "rename_item",
          "delete_item"
        ]
      },
      "result": {
        "type": "string",
        "enum": [
          "success",
          "failure",
          "blocked"
        ]
      },
      "cta_mode": {
        "type": "string",
        "enum": [
          "testflight",
          "app_store",
          "download"
        ]
      },
      "reason": {
        "type": "string",
        "enum": [
          "editing_disabled"
        ],
        "optional": true
      }
    }
  },
  "guest_shared_list_cta_impression": {
    "eventSchemaVersion": 2,
    "properties": {
      "surface": {
        "type": "string",
        "enum": [
          "shared_list"
        ]
      },
      "access_state": {
        "type": "string",
        "enum": [
          "editable",
          "read_only",
          "expired",
          "access_unavailable",
          "not_found",
          "load_error"
        ]
      },
      "cta_mode": {
        "type": "string",
        "enum": [
          "testflight",
          "app_store",
          "download"
        ]
      }
    }
  },
  "guest_shared_list_cta_click": {
    "eventSchemaVersion": 1,
    "properties": {
      "surface": {
        "type": "string",
        "enum": [
          "shared_list"
        ]
      },
      "access_state": {
        "type": "string",
        "enum": [
          "editable",
          "read_only",
          "expired",
          "access_unavailable",
          "not_found",
          "load_error"
        ]
      },
      "cta_mode": {
        "type": "string",
        "enum": [
          "testflight",
          "app_store",
          "download"
        ]
      }
    }
  }
});
export const webProductEventNames = Object.freeze(Object.keys(webProductEventContracts));
